// eslint-disable-next-line import/extensions
import BaseService from '@/services/base.service';
import { switchColorShades, darkModeToggle } from '@/utils/colorsUtils';

const initialState = {
  templatePlaceholders: [],
  colorPallet: 'legacy',
  darkMode: false
};

const getters = {
  getTemplatePlaceholders: (state) => state.templatePlaceholders,
  getDarkMode: (state) => state.darkMode
};

const actions = {
  async fetchTemplatePlaceholders({ commit }) {
    const templateService = new BaseService();

    const { data: { status, result } } = await templateService.get('editor/list');

    if (status === 'success') {
      commit('setTemplatePlaceholders', result);
      return Promise.resolve(result);
    }

    return Promise.reject();
  },
  themeHandler({ commit }) {
    const isDark = localStorage.getItem('darkMode') === 'true' || (!('darkMode' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);

    const colorPallet = JSON.parse(localStorage.getItem('colorPallet'));

    if (isDark) {
      commit('setDarkMode', true);
    }

    if (colorPallet) {
      commit('setColorPallet', colorPallet);
    }
  }
};

const mutations = {
  setTemplatePlaceholders(state, templatePlaceholders) {
    state.templatePlaceholders = templatePlaceholders;
  },
  setColorPallet(state, colorPallet) {
    state.colorPallet = colorPallet;

    localStorage.setItem('colorPallet', JSON.stringify(colorPallet));
    switchColorShades('primary', colorPallet);
  },
  setDarkMode(state) {
    state.darkMode = !state.darkMode;
    localStorage.setItem('darkMode', state.darkMode);
    darkModeToggle(state.darkMode);
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
